import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ModalController } from "@ionic/angular";
import { DateTime } from "luxon";
import { CheckStatusDbDao } from "../../../core/dao/db/checkStatus.db.dao";
import { DepartureMaterialDto } from "../../../core/dto/material.dto";
import { CheckStatus } from "../../../core/models/checkStatus";
import { DateHelper } from "../../../gyzmo-commons/helpers/date.helper";
import { DATE_FORMAT_FOR_PICKER, PARSE_DATE_HOUR_FORMAT } from "../../../gyzmo-commons/interfaces/constants";
import { DateProvider } from "../../../gyzmo-commons/interfaces/dateProvider";
import { FormValidationBaseComponent } from "../../../gyzmo-commons/pages/formValidation.base.component";
import { LoggerService } from "../../../gyzmo-commons/services/logs/logger.service";
import { EquipmentSearchModal } from "../../modal/equipment-search/equipment-search.modal";

@Component({
    selector: "material-line-departure-matid",
    templateUrl: "material-line-departure-matid.component.html",
    styleUrls: ["material-line-departure-matid.component.scss"],
})
export class MaterialLineDepartureMatidComponent extends FormValidationBaseComponent implements OnInit {
    @Input() line: DepartureMaterialDto;
    @Input() lines: DepartureMaterialDto[];
    @Output() validateLineClick: EventEmitter<DepartureMaterialDto> = new EventEmitter();

    collapsed: boolean = false;
    showDateModification: boolean = false;

    checkStatusMatId: CheckStatus[] = [];

    constructor(logger: LoggerService,
                private dateProvider: DateProvider,
                private checkStatusDbDao: CheckStatusDbDao,
                private modalController: ModalController) {
        super(logger);
    }

    async ngOnInit() {
        super.ngOnInit();

        this.checkStatusMatId = await this.checkStatusDbDao.listForMatIDAndDeparture();

        let controls: any = {};
        this.formGroup = new FormGroup(controls);
    }

    onValidateLine() {
        if (this.formGroup.invalid) {
            this.formGroup.markAllAsTouched();
        } else {
            if (this.formGroup.get("realDepartureDate").value && this.formGroup.get("realDepartureTime").value) {
                this.line.date = DateHelper.tryFromFormat((this.formGroup.get("realDepartureDate").value as DateTime).toFormat(DATE_FORMAT_FOR_PICKER)
                                                          + " "
                                                          + this.formGroup.get("realDepartureTime").value, PARSE_DATE_HOUR_FORMAT);
            } else {
                this.line.date = this.dateProvider.now();
            }

            this.line.preparedQuantity = 1;
            this.line.status = this.checkStatusMatId.find(value => {
                return value.id == this.formGroup.get("status").value;
            });

            this.line.remainingQuantityToPrepare = this.line.savedRemainingQuantityToPrepare - this.line.preparedQuantity;

            if (this.line.equipment.personalModel.counterKind.id != "0") {
                this.line.movement.startMileage = this.formGroup.get("departureMileage").value;
            }
            if (this.line.equipment.personalModel.counterKind2.id != "0") {
                this.line.movement.startMileage2 = this.formGroup.get("departureMileage2").value;
            }

            if (this.validateLineClick) {
                this.validateLineClick.emit(this.line);
            }

            if (this.line.isFullyPrepared()) {
                this.collapsed = true;
            }
        }
    }

    public async selectEquipment() {
        let modal = await this.modalController.create({
            component: EquipmentSearchModal,
            componentProps: { model: this.line.equipment.model, lines: this.lines },
            backdropDismiss: false,
        });
        void modal.onDidDismiss()
            .then(result => {
                if (result.data) {
                    this.line.equipment = result.data;
                    this.line.preparedQuantity = 1;

                    this.createFormControl();
                }
            });
        void modal.present();
    }

    private createFormControl() {
        let controls: any = {};

        if (this.line.status) {
            controls.status = new FormControl(this.line.status.id, [Validators.required]);
        } else {
            controls.status = new FormControl(this.checkStatusMatId[0].id, [Validators.required]);
        }

        controls.realDepartureDate = new FormControl("");
        controls.realDepartureTime = new FormControl("");

        if (this.line.equipment.personalModel.counterKind.id != "0") {
            controls.departureMileage = new FormControl(this.line.movement.startMileage, [Validators.required,
                                                                                          Validators.min(0)]);
        } else {
            controls.departureMileage = new FormControl("", []);
        }
        if (this.line.equipment.personalModel.counterKind2.id != "0") {
            controls.departureMileage2 = new FormControl(this.line.movement.startMileage2, [Validators.required,
                                                                                            Validators.min(0)]);
        } else {
            controls.departureMileage2 = new FormControl("", []);
        }

        this.collapsed = this.line.isFullyPrepared();

        this.formGroup = new FormGroup(controls);
    }
}
